// extracted by mini-css-extract-plugin
module.exports = {"main":"Notifications_main__2d7pC","box":"Notifications_box__24-kQ"};